export default "__VITE_ASSET__DeE8Ub3g__"